import classNames from 'classnames';
import { FC } from 'react';

import ErrorMessage from '../../content-blocks/GravityForms/GravityFormsFields/ErrorMessage';
import { useSubmitForm } from '../../services/marketo/api/hooks';
import { SubmitFormResponse } from '../../services/marketo/api/types';
import Button from '../Button';
import Input from '../Input';

import style from './marketo-form.module.css';

interface Props {
  className?: string;
  marketoFormId: null | string | undefined;
  onSuccess?: (response: SubmitFormResponse) => void;
}

const MarketoForm: FC<Props> = ({
  className,
  marketoFormId,
  onSuccess,
}) => {
  const {
    error,
    isPending,
    mutate: submitForm,
  } = useSubmitForm();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!marketoFormId) {
      return;
    }

    const formData = Object.fromEntries(new FormData(event.currentTarget));

    // although the email field is marked as required, an enterprising user
    // could delete the `required` attribute in the browser dev tools and submit the form
    if (!formData.email) {
      return;
    }

    submitForm({
      formId: Number(marketoFormId),
      input: [{
        leadFormFields: {
          email: formData.email as string,
        },
        visitorData: {
          pageURL: window.location.href,
          queryString: window.location.search,
          userAgentString: window.navigator.userAgent,
        },
      }],
    }, {
      onSuccess,
    });
  };

  return (
    <form
      className={classNames(
        style.marketoForm,
        className,
      )}
      onSubmit={handleSubmit}
    >
      <Input
        autoComplete="email"
        hideLabel
        inputMode="email"
        label="Email Address"
        name="email"
        placeholder="Email Address"
        required
        type="email"
      />

      <Button isLoading={isPending}>
        Submit
      </Button>

      {error && (
        <ErrorMessage>
          {error.message}
        </ErrorMessage>
      )}
    </form>
  );
};

export default MarketoForm;
